/* eslint-disable react/jsx-props-no-spreading */
import { inMarketTheme } from '@inmarket/inmarkit';
import AttachMoneyIcon from '@mui/icons-material/AttachMoneyOutlined';
import ErrorOutline from '@mui/icons-material/ErrorOutlineOutlined';
import LoopIcon from '@mui/icons-material/LoopOutlined';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOnOutlined';
import Mouse from '@mui/icons-material/MouseOutlined';
import RequestQuoteIcon from '@mui/icons-material/RequestQuoteOutlined';
import TrendingUpIcon from '@mui/icons-material/TrendingUpOutlined';
import VideocamIcon from '@mui/icons-material/VideocamOutlined';
import VisibilityIcon from '@mui/icons-material/VisibilityOutlined';
import { Card, CircularProgress, Stack, Typography } from '@mui/material';
import currency from 'currency.js';
import get from 'lodash-es/get';
import React from 'react';

import useContractSummaryData from '../../hooks/useContractSummaryData';
import { addCommas, isBlank } from '../../util/helpers';

interface ContractSummaryDataProps {
  contractId: number;
}

const metaData = [
  {
    icon: <VisibilityIcon />,
    label: 'Impressions',
  },
  {
    icon: <Mouse />,
    label: 'Clicks',
  },
  {
    icon: <LoopIcon />,
    label: 'Conversions',
  },
  {
    icon: <TrendingUpIcon />,
    label: 'CTR',
    suffix: '%',
  },
  {
    icon: <VideocamIcon />,
    label: 'VCR',
  },
  {
    icon: <MonetizationOnIcon />,
    label: 'eCPM',
    prefix: '$',
  },
  {
    icon: <RequestQuoteIcon />,
    label: 'Internal Spend',
    prefix: '$',
  },
  {
    icon: <ErrorOutline />,
    label: '3P Discrepancy',
    suffix: '%',
  },
  {
    icon: <AttachMoneyIcon />,
    label: 'Margin',
    suffix: '%',
  },
];

const round = (value) => !isBlank(value) && addCommas(currency(value, { symbol: '', precision: 2 }).value) || '--';

function ContractSummaryData({ contractId }: ContractSummaryDataProps) {
  const { data: json, isLoading, isSuccess } = useContractSummaryData(contractId);
  const data = Object.values(get(json, 'data.0', {}));

  return (
    <Card sx={{ width: '100%' }}>
      <Stack direction="row" m={2} spacing={2} justifyContent="space-between">
        {isLoading && <CircularProgress />}
        {isSuccess &&
          data?.map((dataItem: number, index) => (
            <Stack width={1} alignItems="center">
              <Stack sx={{ color: inMarketTheme.palette.primary.main }} mb={1}>
                {metaData[index].icon}
              </Stack>
              <Typography variant="caption" color="gray">
                {metaData[index].label}
              </Typography>
              <Typography variant="h5">
                {metaData[index].prefix}
                {round(dataItem)}
                {metaData[index].suffix}
              </Typography>
            </Stack>
          ))}
        {isSuccess && data?.length === 0 && <Typography>No data</Typography>}
      </Stack>
    </Card>
  );
}

export default ContractSummaryData;
